/**
 * Component for handling account form inputs
 * @author Housefolios
 * @modifiedBy David Helmick
 * @modifiedTime 2025-06-17 13:55:00
 */

import React from 'react'
import {
  Grid,
  FormControlLabel,
  Checkbox,
  Link,
  Card,
  CardContent,
  Typography,
} from '@mui/material'
import { Link as RouterLink } from 'react-router'

import FormSection from '../Shared/FormSection'
import {
  AUTH_PRIMARY_COLOR,
  AuthCardHeader,
  AuthNavLink,
  AuthPrimaryButton,
  authCardSx,
  authCardWrapSx,
  authFlexSpacerSx,
  authTextEndSx,
} from '../../SignIn/authChrome'

const AccountForm = ({
  headerImage,
  email,
  setEmail,
  firstName,
  setFirstName,
  lastName,
  setLastName,
  phoneNumber,
  setPhoneNumber,
  password,
  setPassword,
  passwordMask,
  setPasswordMask,
  agree,
  setAgree,
  signUpError,
}) => {
  return (
    <Grid sx={authCardWrapSx}>
      <Card sx={authCardSx}>
        <CardContent>
          <Grid container direction="column" spacing={4}>
            <Grid>
              <AuthCardHeader
                title="Create account"
                subtitle="Enter your details to create an account"
                logoSrc={headerImage}
              />
            </Grid>
            <Grid>
              <Grid
                container
                direction="row"
                spacing={2}
                sx={{
                  alignItems: 'center',
                }}
              >
                <FormSection
                  halfSizeName={true}
                  email={email}
                  setEmail={setEmail}
                  password={password}
                  setPassword={setPassword}
                  passwordMask={passwordMask}
                  setPasswordMask={setPasswordMask}
                  firstName={firstName}
                  setFirstName={setFirstName}
                  lastName={lastName}
                  setLastName={setLastName}
                  phoneNumber={phoneNumber}
                  setPhoneNumber={setPhoneNumber}
                  signUpError={signUpError}
                />
                <Grid size={12}>
                  <Grid container direction="column" spacing={2}>
                    <Grid>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={agree}
                            required
                            onChange={() => setAgree(!agree)}
                          />
                        }
                        label={
                          <span>
                            I agree to the{' '}
                            <Link
                              component={RouterLink}
                              to="/Terms"
                              underline="hover"
                              style={{
                                color: AUTH_PRIMARY_COLOR,
                              }}
                              target="_blank"
                            >
                              Terms of Service
                            </Link>{' '}
                            and{' '}
                            <Link
                              component={RouterLink}
                              to="/Privacy"
                              underline="hover"
                              style={{
                                color: AUTH_PRIMARY_COLOR,
                              }}
                              target="_blank"
                            >
                              Privacy Policy
                            </Link>
                          </span>
                        }
                      />
                    </Grid>
                    <Grid>
                      <AuthPrimaryButton type="submit">
                        Next
                      </AuthPrimaryButton>
                    </Grid>
                    <Grid>
                      <Grid
                        container
                        direction="row"
                        wrap="nowrap"
                        sx={{
                          alignItems: 'center',
                        }}
                      >
                        <Grid>
                          <AuthNavLink href="/ForgotPassword">
                            Forgot password
                          </AuthNavLink>
                        </Grid>
                        <Typography sx={authFlexSpacerSx} />
                        <Grid sx={authTextEndSx}>
                          <AuthNavLink href="/signin">
                            Sign in
                          </AuthNavLink>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Grid>
  )
}

export default AccountForm
